import Image, { ImageProps } from 'next/image';
import React, { FC, memo } from 'react';
// import { ImageMedia } from '~/lib/data-contract';
import styles from './media-image.module.css';
import clsx from 'clsx';
import { DigizuiteImageLoaderProps, digizuiteLoader } from './loaders/digizuiteLoader';
import { defaultLoader } from './loaders/defaultLoader';

type Props = ImageProps & DigizuiteImageLoaderProps;

const MediaImageComponent: FC<Props> = (props) => {
    const {
        focalPoint,
        className,
        style,
        src = '',
        assetId,
        quality = 80,
        mimeType,
        cH,
        cW,
        aspectType,
        gravity,
        dimensions,
        ...rest
    } = props;
    
    if (!props || !props.src) {
        console.warn('MediaImage: No image source provided');
        return null;
    }

    const isStatic = !/^https?:\/\//.test(src.toString());
    const isSvg = mimeType === 'image/svg+xml' || src.toString().includes('.svg');

    const loader = isStatic
        ? undefined
        : isSvg
        ? defaultLoader
        : digizuiteLoader({
              //   height,
              mimeType,
              aspectType,
              cH,
              cW,
              gravity,
              assetId,
              focalPoint,
              dimensions,
          });

    const objectPosition = focalPoint
        ? `${focalPoint[0] * 100}% ${focalPoint[1] * 100}%`
        : undefined;

    return (
        <Image
            loader={loader}
            quality={quality}
            className={clsx(styles.root, className)}
            src={src}
            style={{ objectPosition, ...style }}
            {...rest}
        />
    );
};

const MediaImage = memo(MediaImageComponent);
MediaImage.displayName = 'MediaImageComponent';

export { MediaImage };
